var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"landing"}},[_c('DiamondDoraAnimation'),_c('Section1'),_c('Section2'),_c('Section3'),_c('Section4'),_c('Section5'),_c('Section6'),_c('Section7')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }